// extracted by mini-css-extract-plugin
module.exports = {"logo-container":"LogoContainer_logo-container__U3oyT","logo":"LogoContainer_logo__D1t4j"};